import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getContent } from "../../../utils/main";
import { setMenu } from "../../../stores/mainSlice";

const Logo = () => {
  var lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "tm";
  const content = useSelector((state) => state.mainSlice.content);
  const open = useSelector((state) => state.mainSlice.menu);
  const dispatch = useDispatch();
  const logoVariant = {
    visible: { opacity: 1, scale: 1 },
    hidden: { opacity: 0, scale: 0 },
  };
  return (
    <motion.div
      variants={logoVariant}
      initial="hidden"
      animate="visible"
      transition={{ ease: "easeOut", duration: 0.5 }}
      className="top box"
    >
      <div className="row">
        <div className="col">
          <Link
            to="/"
            className="d-flex align-items-center justify-content-center pb-2 pt-2"
          >
            <img
              src={require("./../../../assets/images/2d-logo.png")}
              alt="Logo"
            />
            <h4 className="mb-0">{getContent(content, "Name", lang)}</h4>
          </Link>
        </div>
        <div className="col-auto mobile-menu-btn justify-content-end align-items-center">
          <div
            className={`menu-icon ${open ? "open" : ""}`}
            onClick={() => dispatch(setMenu())}
          >
            <div></div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Logo;
